module.exports = __webpack_public_path__ + "static/img/03.273e7ce2.png";